var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipeResponsive2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1562,
    height: 172,
    viewBox: "-100 0 1562 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1053.98 182.822V182.694V182.514V182.41V146.931H1014L1014 182.514V182.66V182.734V182.88V185.248V185.37L1014 186.711H1054L1053.98 182.822Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1049.37 179.129V179.031V178.893V178.813V151.521H1018.62L1018.62 178.893V179.005V179.062V179.174V180.996V181.09L1018.62 182.121H1049.38L1049.37 179.129Z",
    fill: "url(#paint0_radial_610_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1053.98 222.601V222.474V222.293V222.19V186.711H1014L1014 222.293V222.44V222.513V222.66V225.027V225.15L1014 226.49H1054L1053.98 222.601Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1049.37 218.909V218.811V218.672V218.592V191.301H1018.62L1018.62 218.672V218.785V218.841V218.954V220.775V220.869L1018.62 221.9H1049.38L1049.37 218.909Z",
    fill: "url(#paint1_radial_610_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1053.98 103.262V103.135V102.955V102.851V67.3718H1014L1014 102.955V103.101V103.174V103.321V105.688V105.811L1014 107.151H1054L1053.98 103.262Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1049.37 99.5698V99.4721V99.3333V99.2534V71.9618H1018.62L1018.62 99.3333V99.4459V99.5023V99.6149V101.436V101.53L1018.62 102.562H1049.38L1049.37 99.5698Z",
    fill: "url(#paint2_radial_610_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1053.98 63.4826V63.3556V63.1751V63.0713V27.5922H1014L1014 63.1751V63.3216V63.3948V63.5413V65.9089V66.0313L1014 67.3718H1054L1053.98 63.4826Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1049.37 59.7903V59.6925V59.5537V59.4739V32.1823H1018.62L1018.62 59.5537V59.6664V59.7227V59.8354V61.6566V61.7508L1018.62 62.782H1049.38L1049.37 59.7903Z",
    fill: "url(#paint3_radial_610_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1093.98 63.4826V63.3556V63.1751V63.0713V27.5922H1054L1054 63.1751V63.3216V63.3948V63.5413V65.9089V66.0313L1054 67.3718H1094L1093.98 63.4826Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1089.37 59.7903V59.6925V59.5537V59.4739V32.1823H1058.62L1058.62 59.5537V59.6664V59.7227V59.8354V61.6566V61.7508L1058.62 62.782H1089.38L1089.37 59.7903Z",
    fill: "url(#paint4_radial_610_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1133.98 63.4826V63.3556V63.1751V63.0713V27.5922H1094L1094 63.1751V63.3216V63.3948V63.5413V65.9089V66.0313L1094 67.3718H1134L1133.98 63.4826Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1129.37 59.7903V59.6925V59.5537V59.4739V32.1823H1098.62L1098.62 59.5537V59.6664V59.7227V59.8354V61.6566V61.7508L1098.62 62.782H1129.38L1129.37 59.7903Z",
    fill: "url(#paint5_radial_610_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1173.98 63.4826V63.3556V63.1751V63.0713V27.5922H1134L1134 63.1751V63.3216V63.3948V63.5413V65.9089V66.0313L1134 67.3718H1174L1173.98 63.4826Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1169.37 59.7903V59.6925V59.5537V59.4739V32.1823H1138.62L1138.62 59.5537V59.6664V59.7227V59.8354V61.6566V61.7508L1138.62 62.782H1169.38L1169.37 59.7903Z",
    fill: "url(#paint6_radial_610_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1173.98 103.262V103.135V102.955V102.851V67.3718H1134L1134 102.955V103.101V103.174V103.321V105.688V105.811L1134 107.151H1174L1173.98 103.262Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1169.37 99.5698V99.4721V99.3333V99.2534V71.9618H1138.62L1138.62 99.3333V99.4459V99.5023V99.6149V101.436V101.53L1138.62 102.562H1169.38L1169.37 99.5698Z",
    fill: "url(#paint7_radial_610_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1173.98 138.069V137.942V137.762V137.658V102.179H1134L1134 137.762V137.908V137.981V138.128V140.496V140.618L1134 141.958H1174L1173.98 138.069Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1169.37 134.377V134.279V134.14V134.061V106.769H1138.62L1138.62 134.14V134.253V134.309V134.422V136.243V136.337L1138.62 137.369H1169.38L1169.37 134.377Z",
    fill: "url(#paint8_radial_610_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1133.98 138.069V137.942V137.762V137.658V102.179H1094L1094 137.762V137.908V137.981V138.128V140.496V140.618L1094 141.958H1134L1133.98 138.069Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1129.37 134.377V134.279V134.14V134.061V106.769H1098.62L1098.62 134.14V134.253V134.309V134.422V136.243V136.337L1098.62 137.369H1129.38L1129.37 134.377Z",
    fill: "url(#paint9_radial_610_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1093.98 138.069V137.942V137.762V137.658V102.179H1054L1054 137.762V137.908V137.981V138.128V140.496V140.618L1054 141.958H1094L1093.98 138.069Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1089.37 134.377V134.279V134.14V134.061V106.769H1058.62L1058.62 134.14V134.253V134.309V134.422V136.243V136.337L1058.62 137.369H1089.38L1089.37 134.377Z",
    fill: "url(#paint10_radial_610_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1053.98 143.042V142.915V142.734V142.631V107.152H1014L1014 142.734V142.881V142.954V143.101V145.468V145.591L1014 146.931H1054L1053.98 143.042Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1049.37 139.35V139.252V139.113V139.033V111.742H1018.62L1018.62 139.113V139.226V139.282V139.395V141.216V141.31L1018.62 142.341H1049.38L1049.37 139.35Z",
    fill: "url(#paint11_radial_610_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M945.985 182.822V182.694V182.514V182.41V146.931H906L906 182.514V182.66V182.734V182.88V185.248V185.37L906 186.711H946L945.985 182.822Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.373 179.129V179.031V178.893V178.813V151.521H910.615L910.615 178.893V179.005V179.062V179.174V180.996V181.09L910.615 182.121H941.385L941.373 179.129Z",
    fill: "url(#paint12_radial_610_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M945.985 103.262V103.135V102.955V102.851V67.3718H906L906 102.955V103.101V103.174V103.321V105.688V105.811L906 107.151H946L945.985 103.262Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.373 99.5698V99.4721V99.3333V99.2534V71.9618H910.615L910.615 99.3333V99.4459V99.5023V99.6149V101.436V101.53L910.615 102.562H941.385L941.373 99.5698Z",
    fill: "url(#paint13_radial_610_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M945.985 63.4826V63.3556V63.1751V63.0713V27.5922H906L906 63.1751V63.3216V63.3948V63.5413V65.9089V66.0313L906 67.3718H946L945.985 63.4826Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.373 59.7903V59.6925V59.5537V59.4739V32.1823H910.615L910.615 59.5537V59.6664V59.7227V59.8354V61.6566V61.7508L910.615 62.782H941.385L941.373 59.7903Z",
    fill: "url(#paint14_radial_610_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M945.985 143.042V142.915V142.734V142.631V107.152H906L906 142.734V142.881V142.954V143.101V145.468V145.591L906 146.931H946L945.985 143.042Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.373 139.35V139.252V139.113V139.033V111.742H910.615L910.615 139.113V139.226V139.282V139.395V141.216V141.31L910.615 142.341H941.385L941.373 139.35Z",
    fill: "url(#paint15_radial_610_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M945.985 222.601V222.474V222.293V222.19V186.711H906L906 222.293V222.44V222.513V222.66V225.027V225.15L906 226.49H946L945.985 222.601Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.373 218.909V218.811V218.672V218.592V191.301H910.615L910.615 218.672V218.785V218.841V218.954V220.775V220.869L910.615 221.9H941.385L941.373 218.909Z",
    fill: "url(#paint16_radial_610_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.9847 182.822V182.694V182.514V182.41V146.931H-2.40697e-05L0 182.514V182.66V182.734V182.88V185.248V185.37L2.40697e-05 186.711H40L39.9847 182.822Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3728 179.129V179.031V178.893V178.813V151.521H4.61536L4.61537 178.893V179.005V179.062V179.174V180.996V181.09L4.61539 182.121H35.3846L35.3728 179.129Z",
    fill: "url(#paint17_radial_610_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.9847 103.262V103.135V102.955V102.851V67.3718H-2.40697e-05L0 102.955V103.101V103.174V103.321V105.688V105.811L2.40697e-05 107.151H40L39.9847 103.262Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3728 99.5698V99.4721V99.3333V99.2534V71.9618H4.61536L4.61537 99.3333V99.4459V99.5023V99.6149V101.436V101.53L4.61539 102.562H35.3846L35.3728 99.5698Z",
    fill: "url(#paint18_radial_610_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.9847 63.4826V63.3556V63.1751V63.0713V27.5922H-2.40697e-05L0 63.1751V63.3216V63.3948V63.5413V65.9089V66.0313L2.40697e-05 67.3718H40L39.9847 63.4826Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3728 59.7903V59.6925V59.5537V59.4739V32.1823H4.61536L4.61537 59.5537V59.6664V59.7227V59.8354V61.6566V61.7508L4.61539 62.782H35.3846L35.3728 59.7903Z",
    fill: "url(#paint19_radial_610_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.9847 143.042V142.915V142.734V142.631V107.152H-2.40697e-05L0 142.734V142.881V142.954V143.101V145.468V145.591L2.40697e-05 146.931H40L39.9847 143.042Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3728 139.35V139.252V139.113V139.033V111.742H4.61536L4.61537 139.113V139.226V139.282V139.395V141.216V141.31L4.61539 142.341H35.3846L35.3728 139.35Z",
    fill: "url(#paint20_radial_610_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.9847 222.601V222.474V222.293V222.19V186.711H-2.40697e-05L0 222.293V222.44V222.513V222.66V225.027V225.15L2.40697e-05 226.49H40L39.9847 222.601Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3728 218.909V218.811V218.672V218.592V191.301H4.61536L4.61537 218.672V218.785V218.841V218.954V220.775V220.869L4.61539 221.9H35.3846L35.3728 218.909Z",
    fill: "url(#paint21_radial_610_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.9847 222.601V222.474V222.293V222.19V186.711H40L40 222.293V222.44V222.513V222.66V225.027V225.15L40 226.49H80L79.9847 222.601Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.3728 218.909V218.811V218.672V218.592V191.301H44.6154L44.6154 218.672V218.785V218.841V218.954V220.775V220.869L44.6154 221.9H75.3846L75.3728 218.909Z",
    fill: "url(#paint22_radial_610_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.985 222.601V222.474V222.293V222.19V186.711H80L80 222.293V222.44V222.513V222.66V225.027V225.15L80 226.49H120L119.985 222.601Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.373 218.909V218.811V218.672V218.592V191.301H84.6154L84.6154 218.672V218.785V218.841V218.954V220.775V220.869L84.6154 221.9H115.385L115.373 218.909Z",
    fill: "url(#paint23_radial_610_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.792 25.1357L173.702 25.0458L173.574 24.9182L173.5 24.8448L148.273 -0.242675L120 27.875L145.3 53.0359L145.404 53.1394L145.457 53.1912L145.561 53.2948L147.244 54.969L147.331 55.0555L148.284 56.0034L176.569 27.875L173.792 25.1357Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.906 25.7678L167.836 25.6987L167.738 25.6005L167.681 25.5441L148.276 6.24598L126.527 27.875L145.989 47.2295L146.069 47.3091L146.109 47.349L146.189 47.4286L147.484 48.7165L147.551 48.783L148.284 49.5122L170.041 27.875L167.906 25.7678Z",
    fill: "url(#paint24_radial_610_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.089 146.946H266.961H266.78H266.676H231V186.711L266.78 186.711H266.927H267.001H267.148H269.529H269.652L271 186.711V146.931L267.089 146.946Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.376 151.533H263.278H263.138H263.058H235.615V182.121L263.138 182.121H263.252H263.308H263.422H265.253H265.348L266.385 182.121V151.521L263.376 151.533Z",
    fill: "url(#paint25_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.089 186.726H266.961H266.78H266.676H231V226.49L266.78 226.49H266.927H267.001H267.148H269.529H269.652L271 226.49V186.711L267.089 186.726Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.376 191.312H263.278H263.138H263.058H235.615V221.9L263.138 221.9H263.252H263.308H263.422H265.253H265.348L266.385 221.9V191.301L263.376 191.312Z",
    fill: "url(#paint26_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307.089 186.726H306.961H306.78H306.676H271V226.49L306.78 226.49H306.927H307.001H307.148H309.529H309.652L311 226.49V186.711L307.089 186.726Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.376 191.312H303.278H303.138H303.058H275.615V221.9L303.138 221.9H303.252H303.308H303.422H305.253H305.348L306.385 221.9V191.301L303.376 191.312Z",
    fill: "url(#paint27_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.089 186.726H346.961H346.78H346.676H311V226.49L346.78 226.49H346.927H347.001H347.148H349.529H349.652L351 226.49V186.711L347.089 186.726Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.376 191.312H343.278H343.138H343.058H315.615V221.9L343.138 221.9H343.252H343.308H343.422H345.253H345.348L346.385 221.9V191.301L343.376 191.312Z",
    fill: "url(#paint28_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.089 107.167H266.961H266.78H266.676H231V146.931L266.78 146.931H266.927H267.001H267.148H269.529H269.652L271 146.931V107.151L267.089 107.167Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.376 111.753H263.278H263.138H263.058H235.615V142.341L263.138 142.341H263.252H263.308H263.422H265.253H265.348L266.385 142.341V111.741L263.376 111.753Z",
    fill: "url(#paint29_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.089 67.387H266.961H266.78H266.676H231V107.151L266.78 107.151H266.927H267.001H267.148H269.529H269.652L271 107.151V67.3718L267.089 67.387Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.376 71.9735H263.278H263.138H263.058H235.615V102.562L263.138 102.562H263.252H263.308H263.422H265.253H265.348L266.385 102.561V71.9618L263.376 71.9735Z",
    fill: "url(#paint30_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.089 27.6074H266.961H266.78H266.676H231V67.3719L266.78 67.3718H266.927H267.001H267.148H269.529H269.652L271 67.3718V27.5922L267.089 27.6074Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.376 32.194H263.278H263.138H263.058H235.615V62.782L263.138 62.782H263.252H263.308H263.422H265.253H265.348L266.385 62.7819V32.1823L263.376 32.194Z",
    fill: "url(#paint31_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307.089 27.6074H306.961H306.78H306.676H271V67.3719L306.78 67.3718H306.927H307.001H307.148H309.529H309.652L311 67.3718V27.5922L307.089 27.6074Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.376 32.194H303.278H303.138H303.058H275.615V62.782L303.138 62.782H303.252H303.308H303.422H305.253H305.348L306.385 62.7819V32.1823L303.376 32.194Z",
    fill: "url(#paint32_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.089 27.6074H346.961H346.78H346.676H311V67.3719L346.78 67.3718H346.927H347.001H347.148H349.529H349.652L351 67.3718V27.5922L347.089 27.6074Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.376 32.194H343.278H343.138H343.058H315.615V62.782L343.138 62.782H343.252H343.308H343.422H345.253H345.348L346.385 62.7819V32.1823L343.376 32.194Z",
    fill: "url(#paint33_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307.089 107.167H306.961H306.78H306.676H271V146.931L306.78 146.931H306.927H307.001H307.148H309.529H309.652L311 146.931V107.151L307.089 107.167Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.376 111.753H303.278H303.138H303.058H275.615V142.341L303.138 142.341H303.252H303.308H303.422H305.253H305.348L306.385 142.341V111.741L303.376 111.753Z",
    fill: "url(#paint34_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1278.09 149.93H1277.96H1277.78H1277.68H1242V189.694L1277.78 189.694H1277.93H1278H1278.15H1280.53H1280.65L1282 189.694V149.915L1278.09 149.93Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1274.38 154.517H1274.28H1274.14H1274.06H1246.62V185.104L1274.14 185.104H1274.25H1274.31H1274.42H1276.25H1276.35L1277.38 185.104V154.505L1274.38 154.517Z",
    fill: "url(#paint35_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1278.09 189.71H1277.96H1277.78H1277.68H1242V229.474L1277.78 229.474H1277.93H1278H1278.15H1280.53H1280.65L1282 229.474V189.694L1278.09 189.71Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1274.38 194.296H1274.28H1274.14H1274.06H1246.62V224.884L1274.14 224.884H1274.25H1274.31H1274.42H1276.25H1276.35L1277.38 224.884V194.284L1274.38 194.296Z",
    fill: "url(#paint36_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1318.09 189.71H1317.96H1317.78H1317.68H1282V229.474L1317.78 229.474H1317.93H1318H1318.15H1320.53H1320.65L1322 229.474V189.694L1318.09 189.71Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1314.38 194.296H1314.28H1314.14H1314.06H1286.62V224.884L1314.14 224.884H1314.25H1314.31H1314.42H1316.25H1316.35L1317.38 224.884V194.284L1314.38 194.296Z",
    fill: "url(#paint37_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1358.09 189.71H1357.96H1357.78H1357.68H1322V229.474L1357.78 229.474H1357.93H1358H1358.15H1360.53H1360.65L1362 229.474V189.694L1358.09 189.71Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1354.38 194.296H1354.28H1354.14H1354.06H1326.62V224.884L1354.14 224.884H1354.25H1354.31H1354.42H1356.25H1356.35L1357.38 224.884V194.284L1354.38 194.296Z",
    fill: "url(#paint38_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1278.09 110.15H1277.96H1277.78H1277.68H1242V149.915L1277.78 149.915H1277.93H1278H1278.15H1280.53H1280.65L1282 149.915V110.135L1278.09 110.15Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1274.38 114.737H1274.28H1274.14H1274.06H1246.62V145.325L1274.14 145.325H1274.25H1274.31H1274.42H1276.25H1276.35L1277.38 145.325V114.725L1274.38 114.737Z",
    fill: "url(#paint39_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1278.09 70.3706H1277.96H1277.78H1277.68H1242V110.135L1277.78 110.135H1277.93H1278H1278.15H1280.53H1280.65L1282 110.135V70.3554L1278.09 70.3706Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1274.38 74.9572H1274.28H1274.14H1274.06H1246.62V105.545L1274.14 105.545H1274.25H1274.31H1274.42H1276.25H1276.35L1277.38 105.545V74.9455L1274.38 74.9572Z",
    fill: "url(#paint40_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1278.09 30.5911H1277.96H1277.78H1277.68H1242V70.3555L1277.78 70.3555H1277.93H1278H1278.15H1280.53H1280.65L1282 70.3554V30.5759L1278.09 30.5911Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1274.38 35.1776H1274.28H1274.14H1274.06H1246.62V65.7656L1274.14 65.7656H1274.25H1274.31H1274.42H1276.25H1276.35L1277.38 65.7656V35.1659L1274.38 35.1776Z",
    fill: "url(#paint41_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1318.09 30.5911H1317.96H1317.78H1317.68H1282V70.3555L1317.78 70.3555H1317.93H1318H1318.15H1320.53H1320.65L1322 70.3554V30.5759L1318.09 30.5911Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1314.38 35.1776H1314.28H1314.14H1314.06H1286.62V65.7656L1314.14 65.7656H1314.25H1314.31H1314.42H1316.25H1316.35L1317.38 65.7656V35.1659L1314.38 35.1776Z",
    fill: "url(#paint42_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1358.09 30.5911H1357.96H1357.78H1357.68H1322V70.3555L1357.78 70.3555H1357.93H1358H1358.15H1360.53H1360.65L1362 70.3554V30.5759L1358.09 30.5911Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1354.38 35.1776H1354.28H1354.14H1354.06H1326.62V65.7656L1354.14 65.7656H1354.25H1354.31H1354.42H1356.25H1356.35L1357.38 65.7656V35.1659L1354.38 35.1776Z",
    fill: "url(#paint43_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1318.09 110.15H1317.96H1317.78H1317.68H1282V149.915L1317.78 149.915H1317.93H1318H1318.15H1320.53H1320.65L1322 149.915V110.135L1318.09 110.15Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1314.38 114.737H1314.28H1314.14H1314.06H1286.62V145.325L1314.14 145.325H1314.25H1314.31H1314.42H1316.25H1316.35L1317.38 145.325V114.725L1314.38 114.737Z",
    fill: "url(#paint44_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M578.985 182.822V182.694V182.514V182.41V146.931H539L539 182.514V182.66V182.734V182.88V185.248V185.37L539 186.711H579L578.985 182.822Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter45_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M574.373 179.129V179.031V178.893V178.813V151.521H543.615L543.615 178.893V179.005V179.062V179.174V180.996V181.09L543.615 182.121H574.385L574.373 179.129Z",
    fill: "url(#paint45_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M458.985 103.262V103.135V102.955V102.851V67.3718H419L419 102.955V103.101V103.174V103.321V105.688V105.811L419 107.151H459L458.985 103.262Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter46_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.373 99.5698V99.4721V99.3333V99.2534V71.9618H423.615L423.615 99.3333V99.4459V99.5023V99.6149V101.436V101.53L423.615 102.562H454.385L454.373 99.5698Z",
    fill: "url(#paint46_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M578.985 103.262V103.135V102.955V102.851V67.3718H539L539 102.955V103.101V103.174V103.321V105.688V105.811L539 107.151H579L578.985 103.262Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter47_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M574.373 99.5698V99.4721V99.3333V99.2534V71.9618H543.615L543.615 99.3333V99.4459V99.5023V99.6149V101.436V101.53L543.615 102.562H574.385L574.373 99.5698Z",
    fill: "url(#paint47_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M458.985 143.042V142.915V142.734V142.631V107.152H419L419 142.734V142.881V142.954V143.101V145.468V145.591L419 146.931H459L458.985 143.042Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.373 139.35V139.252V139.113V139.033V111.742H423.615L423.615 139.113V139.226V139.282V139.395V141.216V141.31L423.615 142.341H454.385L454.373 139.35Z",
    fill: "url(#paint48_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M578.985 143.042V142.915V142.734V142.631V107.152H539L539 142.734V142.881V142.954V143.101V145.468V145.591L539 146.931H579L578.985 143.042Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter49_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M574.373 139.35V139.252V139.113V139.033V111.742H543.615L543.615 139.113V139.226V139.282V139.395V141.216V141.31L543.615 142.341H574.385L574.373 139.35Z",
    fill: "url(#paint49_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M458.985 63.4826V63.3556V63.1751V63.0713V27.5922H419L419 63.1751V63.3216V63.3948V63.5413V65.9089V66.0313L419 67.3718H459L458.985 63.4826Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter50_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.373 59.7903V59.6925V59.5537V59.4739V32.1823H423.615L423.615 59.5537V59.6664V59.7227V59.8354V61.6566V61.7508L423.615 62.782H454.385L454.373 59.7903Z",
    fill: "url(#paint50_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M498.985 63.4826V63.3556V63.1751V63.0713V27.5922H459L459 63.1751V63.3216V63.3948V63.5413V65.9089V66.0313L459 67.3718H499L498.985 63.4826Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter51_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.373 59.7903V59.6925V59.5537V59.4739V32.1823H463.615L463.615 59.5537V59.6664V59.7227V59.8354V61.6566V61.7508L463.615 62.782H494.385L494.373 59.7903Z",
    fill: "url(#paint51_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M538.985 63.4826V63.3556V63.1751V63.0713V27.5922H499L499 63.1751V63.3216V63.3948V63.5413V65.9089V66.0313L499 67.3718H539L538.985 63.4826Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter52_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M534.373 59.7903V59.6925V59.5537V59.4739V32.1823H503.615L503.615 59.5537V59.6664V59.7227V59.8354V61.6566V61.7508L503.615 62.782H534.385L534.373 59.7903Z",
    fill: "url(#paint52_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M498.985 222.601V222.474V222.293V222.19V186.711H459L459 222.293V222.44V222.513V222.66V225.027V225.15L459 226.49H499L498.985 222.601Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter53_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.373 218.909V218.811V218.672V218.592V191.301H463.615L463.615 218.672V218.785V218.841V218.954V220.775V220.869L463.615 221.9H494.385L494.373 218.909Z",
    fill: "url(#paint53_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M538.985 222.601V222.474V222.293V222.19V186.711H499L499 222.293V222.44V222.513V222.66V225.027V225.15L499 226.49H539L538.985 222.601Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter54_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M534.373 218.909V218.811V218.672V218.592V191.301H503.615L503.615 218.672V218.785V218.841V218.954V220.775V220.869L503.615 221.9H534.385L534.373 218.909Z",
    fill: "url(#paint54_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M578.985 222.601V222.474V222.293V222.19V186.711H539L539 222.293V222.44V222.513V222.66V225.027V225.15L539 226.49H579L578.985 222.601Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter55_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M574.373 218.909V218.811V218.672V218.592V191.301H543.615L543.615 218.672V218.785V218.841V218.954V220.775V220.869L543.615 221.9H574.385L574.373 218.909Z",
    fill: "url(#paint55_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M578.792 198.177L578.702 198.087L578.574 197.96L578.5 197.886L553.273 172.799L525 200.917L550.3 226.077L550.404 226.181L550.457 226.233L550.561 226.336L552.244 228.01L552.331 228.097L553.284 229.045L581.569 200.916L578.792 198.177Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter56_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M578.906 205.77L578.836 205.701L578.738 205.603L578.681 205.547L559.276 186.249L537.527 207.878L556.989 227.232L557.069 227.312L557.109 227.352L557.189 227.431L558.484 228.719L558.551 228.786L559.284 229.515L581.041 207.878L578.906 205.77Z",
    fill: "url(#paint56_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M606.792 226.023L606.702 225.933L606.574 225.805L606.5 225.732L581.273 200.644L553 228.762L578.3 253.923L578.404 254.026L578.457 254.078L578.561 254.182L580.244 255.856L580.331 255.942L581.284 256.89L609.569 228.762L606.792 226.023Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter57_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.906 226.655L600.836 226.586L600.738 226.487L600.681 226.431L581.276 207.133L559.527 228.762L578.989 248.116L579.069 248.196L579.109 248.236L579.189 248.316L580.484 249.603L580.551 249.67L581.284 250.399L603.041 228.762L600.906 226.655Z",
    fill: "url(#paint57_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M578.985 63.4826V63.3556V63.1751V63.0713V27.5922H539L539 63.1751V63.3216V63.3948V63.5413V65.9089V66.0313L539 67.3718H579L578.985 63.4826Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter58_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M574.373 59.7903V59.6925V59.5537V59.4739V32.1823H543.615L543.615 59.5537V59.6664V59.7227V59.8354V61.6566V61.7508L543.615 62.782H574.385L574.373 59.7903Z",
    fill: "url(#paint58_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M458.985 222.601V222.474V222.293V222.19V186.711H419L419 222.293V222.44V222.513V222.66V225.027V225.15L419 226.49H459L458.985 222.601Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter59_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.373 218.909V218.811V218.672V218.592V191.301H423.615L423.615 218.672V218.785V218.841V218.954V220.775V220.869L423.615 221.9H454.385L454.373 218.909Z",
    fill: "url(#paint59_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M458.985 182.822V182.694V182.514V182.41V146.931H419L419 182.514V182.66V182.734V182.88V185.248V185.37L419 186.711H459L458.985 182.822Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter60_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.373 179.129V179.031V178.893V178.813V151.521H423.615L423.615 178.893V179.005V179.062V179.174V180.996V181.09L423.615 182.121H454.385L454.373 179.129Z",
    fill: "url(#paint60_radial_610_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M754.089 184.737H753.961H753.78H753.676H718V224.501L753.78 224.501H753.927H754.001H754.148H756.529H756.652L758 224.501V184.722L754.089 184.737Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter61_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M750.377 189.323H750.278H750.139H750.058H722.616V219.911L750.139 219.911H750.252H750.309H750.422H752.253H752.348L753.385 219.911V189.312L750.377 189.323Z",
    fill: "url(#paint61_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M714.089 105.178H713.961H713.78H713.676H678V144.942L713.78 144.942H713.927H714.001H714.148H716.529H716.652L718 144.942V105.163L714.089 105.178Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter62_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M710.377 109.764H710.278H710.139H710.058H682.616V140.352L710.139 140.352H710.252H710.309H710.422H712.253H712.348L713.385 140.352V109.752L710.377 109.764Z",
    fill: "url(#paint62_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M714.089 144.958H713.961H713.78H713.676H678V184.722L713.78 184.722H713.927H714.001H714.148H716.529H716.652L718 184.722V144.942L714.089 144.958Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter63_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M710.377 149.544H710.278H710.139H710.058H682.616V180.132L710.139 180.132H710.252H710.309H710.422H712.253H712.348L713.385 180.132V149.532L710.377 149.544Z",
    fill: "url(#paint63_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M714.089 184.737H713.961H713.78H713.676H678V224.501L713.78 224.501H713.927H714.001H714.148H716.529H716.652L718 224.501V184.722L714.089 184.737Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter64_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M710.377 189.323H710.278H710.139H710.058H682.616V219.911L710.139 219.911H710.252H710.309H710.422H712.253H712.348L713.385 219.911V189.312L710.377 189.323Z",
    fill: "url(#paint64_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M794.089 184.737H793.961H793.78H793.676H758V224.501L793.78 224.501H793.927H794.001H794.148H796.529H796.652L798 224.501V184.722L794.089 184.737Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter65_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M790.377 189.323H790.278H790.139H790.058H762.616V219.911L790.139 219.911H790.252H790.309H790.422H792.253H792.348L793.385 219.911V189.312L790.377 189.323Z",
    fill: "url(#paint65_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M834.089 144.958H833.961H833.78H833.676H798V184.722L833.78 184.722H833.927H834.001H834.148H836.529H836.652L838 184.722V144.942L834.089 144.958Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter66_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M830.377 149.544H830.278H830.139H830.058H802.616V180.132L830.139 180.132H830.252H830.309H830.422H832.253H832.348L833.385 180.132V149.532L830.377 149.544Z",
    fill: "url(#paint66_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M834.089 105.178H833.961H833.78H833.676H798V144.942L833.78 144.942H833.927H834.001H834.148H836.529H836.652L838 144.942V105.163L834.089 105.178Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter67_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M830.377 109.764H830.278H830.139H830.058H802.616V140.352L830.139 140.352H830.252H830.309H830.422H832.253H832.348L833.385 140.352V109.752L830.377 109.764Z",
    fill: "url(#paint67_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M834.089 65.3982H833.961H833.78H833.676H798V105.163L833.78 105.163H833.927H834.001H834.148H836.529H836.652L838 105.163V65.383L834.089 65.3982Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter68_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M830.377 69.9845H830.278H830.139H830.058H802.616V100.573L830.139 100.572H830.252H830.309H830.422H832.253H832.348L833.385 100.572V69.9728L830.377 69.9845Z",
    fill: "url(#paint68_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M834.089 25.6187H833.961H833.78H833.676H798V65.3831L833.78 65.3831H833.927H834.001H834.148H836.529H836.652L838 65.383V25.6034L834.089 25.6187Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter69_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M830.377 30.205H830.278H830.139H830.058L802.616 30.205V60.793L830.139 60.793H830.252H830.309H830.422H832.253H832.348L833.385 60.7929V30.1933L830.377 30.205Z",
    fill: "url(#paint69_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M834.089 184.737H833.961H833.78H833.676H798V224.501L833.78 224.501H833.927H834.001H834.148H836.529H836.652L838 224.501V184.722L834.089 184.737Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter70_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M830.377 189.323H830.278H830.139H830.058H802.616V219.911L830.139 219.911H830.252H830.309H830.422H832.253H832.348L833.385 219.911V189.312L830.377 189.323Z",
    fill: "url(#paint70_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M714.089 65.3982H713.961H713.78H713.676H678V105.163L713.78 105.163H713.927H714.001H714.148H716.529H716.652L718 105.163V65.383L714.089 65.3982Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter71_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M710.377 69.9845H710.278H710.139H710.058H682.616V100.573L710.139 100.572H710.252H710.309H710.422H712.253H712.348L713.385 100.572V69.9728L710.377 69.9845Z",
    fill: "url(#paint71_radial_610_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M714.089 25.6187H713.961H713.78H713.676H678V65.3831L713.78 65.3831H713.927H714.001H714.148H716.529H716.652L718 65.383V25.6034L714.089 25.6187Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter72_f_610_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M710.377 30.205H710.278H710.139H710.058L682.616 30.205V60.793L710.139 60.793H710.252H710.309H710.422H712.253H712.348L713.385 60.7929V30.1933L710.377 30.205Z",
    fill: "url(#paint72_radial_610_2)",
    fillOpacity: 0.55
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_610_2",
    x: 1012.62,
    y: 145.521,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_610_2",
    x: 1012.62,
    y: 185.301,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_610_2",
    x: 1012.62,
    y: 65.9619,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_610_2",
    x: 1012.62,
    y: 26.1824,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_610_2",
    x: 1052.62,
    y: 26.1824,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_610_2",
    x: 1092.62,
    y: 26.1824,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_610_2",
    x: 1132.62,
    y: 26.1824,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_610_2",
    x: 1132.62,
    y: 65.9619,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_610_2",
    x: 1132.62,
    y: 100.769,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_610_2",
    x: 1092.62,
    y: 100.769,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_610_2",
    x: 1052.62,
    y: 100.769,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_610_2",
    x: 1012.62,
    y: 105.742,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_610_2",
    x: 904.615,
    y: 145.521,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_610_2",
    x: 904.615,
    y: 65.9619,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_610_2",
    x: 904.615,
    y: 26.1824,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_610_2",
    x: 904.615,
    y: 105.742,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_610_2",
    x: 904.615,
    y: 185.301,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_610_2",
    x: -1.38464,
    y: 145.521,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_610_2",
    x: -1.38464,
    y: 65.9619,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_610_2",
    x: -1.38464,
    y: 26.1824,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_610_2",
    x: -1.38464,
    y: 105.742,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_610_2",
    x: -1.38464,
    y: 185.301,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_610_2",
    x: 38.6154,
    y: 185.301,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_610_2",
    x: 78.6154,
    y: 185.301,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_610_2",
    x: 120.527,
    y: 0.246094,
    width: 55.5142,
    height: 55.2661,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_610_2",
    x: 229.615,
    y: 145.521,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_610_2",
    x: 229.615,
    y: 185.301,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_610_2",
    x: 269.615,
    y: 185.301,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_610_2",
    x: 309.615,
    y: 185.301,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_610_2",
    x: 229.615,
    y: 105.741,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_610_2",
    x: 229.615,
    y: 65.9619,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_f_610_2",
    x: 229.615,
    y: 26.1824,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_f_610_2",
    x: 269.615,
    y: 26.1824,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_f_610_2",
    x: 309.615,
    y: 26.1824,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_f_610_2",
    x: 269.615,
    y: 105.741,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_f_610_2",
    x: 1240.62,
    y: 148.505,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_f_610_2",
    x: 1240.62,
    y: 188.284,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_f_610_2",
    x: 1280.62,
    y: 188.284,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_f_610_2",
    x: 1320.62,
    y: 188.284,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_f_610_2",
    x: 1240.62,
    y: 108.725,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_f_610_2",
    x: 1240.62,
    y: 68.9456,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_f_610_2",
    x: 1240.62,
    y: 29.166,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_f_610_2",
    x: 1280.62,
    y: 29.166,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_f_610_2",
    x: 1320.62,
    y: 29.166,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_f_610_2",
    x: 1280.62,
    y: 108.725,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_f_610_2",
    x: 537.615,
    y: 145.521,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_f_610_2",
    x: 417.615,
    y: 65.9619,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_f_610_2",
    x: 537.615,
    y: 65.9619,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_f_610_2",
    x: 417.615,
    y: 105.742,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_f_610_2",
    x: 537.615,
    y: 105.742,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_f_610_2",
    x: 417.615,
    y: 26.1824,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_f_610_2",
    x: 457.615,
    y: 26.1824,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_f_610_2",
    x: 497.615,
    y: 26.1824,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_f_610_2",
    x: 457.615,
    y: 185.301,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_f_610_2",
    x: 497.615,
    y: 185.301,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_f_610_2",
    x: 537.615,
    y: 185.301,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_f_610_2",
    x: 531.527,
    y: 180.249,
    width: 55.5142,
    height: 55.2661,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_f_610_2",
    x: 553.527,
    y: 201.133,
    width: 55.5142,
    height: 55.2661,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_f_610_2",
    x: 537.615,
    y: 26.1824,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter59_f_610_2",
    x: 417.615,
    y: 185.301,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter60_f_610_2",
    x: 417.615,
    y: 145.521,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter61_f_610_2",
    x: 716.615,
    y: 183.312,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter62_f_610_2",
    x: 676.615,
    y: 103.752,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter63_f_610_2",
    x: 676.615,
    y: 143.532,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter64_f_610_2",
    x: 676.615,
    y: 183.312,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter65_f_610_2",
    x: 756.615,
    y: 183.312,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter66_f_610_2",
    x: 796.615,
    y: 143.532,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter67_f_610_2",
    x: 796.615,
    y: 103.752,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter68_f_610_2",
    x: 796.615,
    y: 63.9729,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter69_f_610_2",
    x: 796.615,
    y: 24.1934,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter70_f_610_2",
    x: 796.615,
    y: 183.312,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter71_f_610_2",
    x: 676.615,
    y: 63.9729,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter72_f_610_2",
    x: 676.615,
    y: 24.1934,
    width: 42.7693,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_610_2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1034.92 166.974) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1034.92 206.754) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1034.92 87.4147) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1034.92 47.6351) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1074.92 47.6351) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1114.92 47.6351) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1154.92 47.6351) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1154.92 87.4147) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1154.92 122.222) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1114.92 122.222) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1074.92 122.222) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1034.92 127.194) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(926.923 166.974) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(926.923 87.4147) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(926.923 47.6351) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(926.923 127.194) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(926.923 206.754) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.923 166.974) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.923 87.4147) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.923 47.6351) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.923 127.194) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.923 206.754) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.923 206.754) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.923 206.754) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.046 27.334) rotate(157.702) scale(22.8102 21.1833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(251.154 165.903) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(251.154 205.683) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(291.154 205.683) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331.154 205.683) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(251.154 126.123) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(251.154 86.3437) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(251.154 46.5641) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(291.154 46.5641) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331.154 46.5641) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(291.154 126.123) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1262.15 168.887) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1262.15 208.666) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1302.15 208.666) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1342.15 208.666) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1262.15 129.107) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1262.15 89.3273) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1262.15 49.5478) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1302.15 49.5478) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1342.15 49.5478) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1302.15 129.107) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(559.923 166.974) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(439.923 87.4147) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(559.923 87.4147) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(439.923 127.194) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(559.923 127.194) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(439.923 47.6351) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(479.923 47.6351) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(519.923 47.6351) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(479.923 206.754) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(519.923 206.754) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(559.923 206.754) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(560.046 207.337) rotate(157.825) scale(28.6638 26.6189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(582.046 228.221) rotate(157.825) scale(28.6638 26.6189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(559.923 47.6351) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(439.923 206.754) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(439.923 166.974) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(738.154 203.694) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(698.154 124.134) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(698.154 163.914) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(698.154 203.694) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(778.154 203.694) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(818.154 163.914) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(818.154 124.134) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(818.154 84.3547) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(818.154 44.5751) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(818.154 203.694) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(698.154 84.3547) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_610_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(698.154 44.5751) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_610_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1362,
    height: 262,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipeResponsive2);
export default __webpack_public_path__ + "static/media/equipe-responsive2.9507b6960608a12a76758740f94513eb.svg";
export { ForwardRef as ReactComponent };